import { DEFAULT_PAGE_SIZE } from './common.types';

export const THEMES = ['system', 'light', 'dark'] as const;
export type ThemePreference = (typeof THEMES)[number];

export const DENSITIES = ['comfortable', 'compact'] as const;
export type DensityPreference = (typeof DENSITIES)[number];

/**
 * The presentation choices a signed-in user has made.
 *
 * Kept in `shared` rather than in the profile feature that edits them, because the
 * components that have to honour them — tables, pagers, date formatting — are shared and
 * must not reach sideways into a feature. The profile feature owns persistence; this owns
 * the vocabulary.
 */
export interface DisplayPreferences {
  readonly theme: ThemePreference;
  readonly density: DensityPreference;
  /** BCP 47 tag driving number and date formatting. */
  readonly locale: string;
  /** IANA zone that timestamps are rendered in. */
  readonly timeZone: string;
  readonly pageSize: number;
}

/**
 * Used before the saved settings arrive, and on pages such as login that have no user to
 * read settings for. `system` and the browser's own zone mean the first paint matches the
 * environment rather than imposing a choice the user then has to undo.
 */
export const DEFAULT_DISPLAY_PREFERENCES: DisplayPreferences = {
  theme: 'system',
  density: 'comfortable',
  locale: 'en-GB',
  timeZone: 'Europe/London',
  pageSize: DEFAULT_PAGE_SIZE,
};
